"use client";

import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { Alert } from "@/components/ui/Alert";
import { apiFetch, errorMessage } from "@/lib/api-client";

type Result = { result: "MATCH_CURRENT" | "MATCH_SUPERSEDED" | "NO_MATCH"; version?: number };

export function CheckFileForm({ publicId }: { publicId: string }) {
  const [file, setFile] = useState<File | null>(null);
  const [result, setResult] = useState<Result | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!file) return;
    setError(null);
    setResult(null);
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const data = await apiFetch<Result>(`/api/verify/${publicId}/check-file`, { method: "POST", body: form });
      setResult(data);
    } catch (err) {
      setError(errorMessage(err, "검증에 실패했습니다."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3">
      {error && <Alert tone="error">{error}</Alert>}
      {result?.result === "MATCH_CURRENT" && <Alert tone="success">일치합니다 — 현재 유효한 인증서입니다.</Alert>}
      {result?.result === "MATCH_SUPERSEDED" && (
        <Alert tone="warning">이전 버전(v{result.version})과 일치합니다 — 최신 인증서로 갱신되었습니다.</Alert>
      )}
      {result?.result === "NO_MATCH" && <Alert tone="error">일치하는 등록 문서를 찾을 수 없습니다.</Alert>}
      <input
        type="file"
        onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        className="text-sm text-body"
      />
      <Button type="submit" variant="secondary" size="sm" className="w-fit" disabled={!file || busy}>
        {busy ? "검증중..." : "파일 검증"}
      </Button>
    </form>
  );
}
